import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=a904352a&"
import script from "./CardFooter.vue?vue&type=script&lang=js&"
export * from "./CardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a904352a')) {
      api.createRecord('a904352a', component.options)
    } else {
      api.reload('a904352a', component.options)
    }
    module.hot.accept("./CardFooter.vue?vue&type=template&id=a904352a&", function () {
      api.rerender('a904352a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/card-layout/CardFooter.vue"
export default component.exports